import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import PayPalCheckout from "./PayPalCheckout";

export default function PaymentFailedPage() {
  const { state } = useLocation();
  const errorDetails = state?.errorDetails;

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Alert variant="warning" className="mb-4">
            <Alert.Heading>Payment Unsuccessful</Alert.Heading>
            <p className="mb-0">
              We couldn't process your payment. You have not been charged.
            </p>
            {errorDetails && (
              <p className="text-muted small mt-2 mb-0">
                <strong>Details:</strong> {errorDetails}
              </p>
            )}
          </Alert>

          <Card>
            <Card.Header as="h5">Complete Your Payment</Card.Header>
            <Card.Body>
              <Card.Text>
                Please complete your payment to access the course.
              </Card.Text>
              <PayPalCheckout />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
